import React, { Component } from 'react'
import { connect } from 'react-redux'

import Comments from 'components/Comments'
import Attachments from 'components/Attachments'

import { attachmentPath } from 'selectors/attachments'

let select = (state, props) => ({
	path: attachmentPath(state, props.objectID)
})

export class RightSide extends Component{
	render(){
		let { props } = this
		let oneColomn = this.props.colspan == 1
		return(
			<div className="rightSide"
				style={{
					width: (this.props.colspan>1)?"50%":"100%"
				  , clear:"both"
					, paddingLeft:"5px"
				  , position: "relative"
				  , display: "block"
				  , overflowY: "hidden"
				  , paddingBottom: "50px"
				}}
			>
				{/*<Attachments objectID={this.props.objectID} path={this.props.path} removable={true} top={this.props.colspan == 2}/>*/}
				<Comments objectID={this.props.objectID} path={this.props.path} />
			</div>
		)
	}
}

export default connect(select)(RightSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/termForm/RightSide.js